import React, { useState } from "react";
import emailjs from "emailjs-com";
import axios from "axios";
import Swal from "sweetalert2";

const FirstComponent = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setUploadMessage(`File uploaded: ${file.name}`);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please upload a file before submitting.",
      });
      return;
    }
    setIsSending(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const uploadResponse = await axios.post("https://file.io", formData);
      const downloadLink = uploadResponse.data.link;

      const emailData = {
        fileName: selectedFile.name,
        downloadLink: downloadLink,
      };
      await emailjs.send(
        "service_ukwpswk",
        "template_b0auxwq",
        emailData,
        "eustvQeLOCU86kDQW"
      );
      setIsSending(false);
      setSelectedFile(null);
      setUploadMessage("");
      Swal.fire({
        icon: "success",
        title: "File Sent!",
        text: "Your file has been successfully sent!",
      });
    } catch (error) {
      console.error("Error during file upload or email send:", error);
      setIsSending(false);
      setErrorMessage(error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage || "An error occurred. Please try again later.",
      });
    }
  };
  return (
    <div className="first-component">
      <div className="desc">
        <p>
          Choose a position from the list to view its details, and if it’s the
          right fit for you, apply directly. We’d be thrilled to have you join
          our team!
        </p>
        <p>
          If there are no available open positions, you can still share your CV
          with us, and we’ll contact you as soon as a suitable opportunity
          arises.
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="file-upload-box">
          <p>* Work Experience</p>
          <div className="input-box upload-area">
            <label htmlFor="fileInput" className="upload-label mb-0">
              <div className="upload-content">
                <div className="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_712_261)">
                      <path
                        d="M32.75 16.7337C31.6167 10.9837 26.5667 6.66699 20.5 6.66699C15.6833 6.66699 11.5 9.40033 9.41667 13.4003C4.4 13.9337 0.5 18.1837 0.5 23.3337C0.5 28.8503 4.98333 33.3337 10.5 33.3337H32.1667C36.7667 33.3337 40.5 29.6003 40.5 25.0003C40.5 20.6003 37.0833 17.0337 32.75 16.7337ZM23.8333 21.667V28.3337H17.1667V21.667H12.1667L20.5 13.3337L28.8333 21.667H23.8333Z"
                        fill="black"
                        fillOpacity="0.6"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_712_261">
                        <rect
                          width="40"
                          height="40"
                          fill="white"
                          transform="translate(0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="text">
                  <p className="mb-2">Drag & Drop your files here</p>
                  <p className="mb-0">(PDF, DOCX, TXT or HTML)</p>
                </div>
              </div>
            </label>
            <input
              type="file"
              id="fileInput"
              accept=".pdf,.docx,.txt,.html"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
          </div>
        </div>
        {uploadMessage && <p className="upload-message">{uploadMessage}</p>}
        <button
          type="submit"
          className="btn"
          disabled={isSending}
          style={{
            opacity: selectedFile ? 1 : 0.5,
            pointerEvents: selectedFile ? "auto" : "none",
          }}
        >
          {isSending ? "Sending..." : "Send File"}
        </button>
      </form>
    </div>
  );
};

export default FirstComponent;
